module.exports = __webpack_public_path__ + "img/sdg5.4e327817.svg";